<template>
  <div class="detail">
    <div >
      <QS-h3-title >
        <template slot="title">付款信息详情</template>
      </QS-h3-title>
    </div>
    <div class="splitline mt16 mb16" />
    <!-- 付款基础信息 -->
    <PayBasisInfo :source="payBasisInfo" />
    <!-- 相关应付信息 -->
    <PayInfo :source="source" />
    <!-- 应付业务信息 -->
    <PayBusinessInfo :source="source" />
  </div>
</template>

<script>
import PayBasisInfo from './components/PayBasisInfo.vue'
import PayInfo from './components/PayInfo.vue'
import PayBusinessInfo from './components/PayBusinessInfo'

import {
  getPaymentOrderDetails,
} from '@/api/financeApi'

export default {
  components: {
    PayBasisInfo,
    PayInfo,
    PayBusinessInfo,
  },
  data() {
    return {
      source: {},
      payBasisInfo: {},
    }
  },
  created() {
    const { id } = this.$route.query
    this.getPaymentOrderDetails(id)
  },
  methods: {
    getPaymentOrderDetails(id) {
      getPaymentOrderDetails({ id }).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          const paymentDetail = data.paymentDetail || {}
          this.payBasisInfo = {
            ...data,
            payeeType: paymentDetail.payeeType,
            amount: this.numberWithCommas(data.amount), // 付款金额
            photo: this.getURL({ data: data.photo }),
          }
          this.source = {
            ...paymentDetail,
            payAmount: this.numberWithCommas(paymentDetail.payAmount), // 付款金额
            paidAmount: this.numberWithCommas(paymentDetail.paidAmount), // 已付金额
          }
        }
      })
    },
  },
}
</script>

<style>

</style>
